import $ = require('jquery');

export class OptimizeNowFaq {
    readonly entryTemplate: string = `
        <div class="faq-item">
        <div class="accordion-header" id="faqHeading{idx}">
            <a class="accordion-button-faq"
                data-toggle="collapse" data-target="#faqCollapse{idx}" href="#faqCollapse{idx}" aria-expanded="false"
            ><div class="faqQuestion float-left">{Question}</div><div class="faq-caret caret-button float-right"><span class="accordion-caret"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6"/></svg></span></div><div class="clearfix"></div></a>
        </div>
        <div 
            id="faqCollapse{idx}" 
            class="accordion-collapse collapse" 
            aria-labelledby="faqHeading{idx}" 
            data-bs-parent="#{containerId}"
        ><div class="accordion-body">{Answer}</div></div></div>

    `;

    readonly idTemplate: string = 'faq_{0}'

    protected faq: FAQ = {
        Url: '/data/faq.json',
        Data: null
    };

    protected $faqContainer: JQuery;

    constructor(protected faqContainerId: string) {
        this.$faqContainer = $(`#${faqContainerId}`);

        if (this.$faqContainer.length == 0) {
            console.warn('container not found');
            return;
        }

        $.get(
            this.faq.Url,
            (data: QnA[]) => {
                try {
                    ///TODO validate data

                    this.faq.Data = data;
                } catch (e) { console.warn(e); return; }

                this.faq.Data.forEach((item, idx) => {
                    this.$faqContainer.append(
                        $('<div></div>', { class: "accordion-item py-1" }).html(
                            this.replaceKeys(this.entryTemplate, { idx: idx, Question: item.Question, Answer: item.Answer, containerId: this.faqContainerId })
                        )
                    );
                });
            },
            'json'
        );

        //var $searchContainer = $(`#${faqSearchContainerId}`);
        //this.eventHandling.$searchBox = $('input', $searchContainer)
        //    .on('input', (ev) => this.eventHandling.searchHandler((<string>$(ev.target).val()).toLowerCase().trim()));

        //this.eventHandling.$resetBtn = $('button', $searchContainer)
        //    .click(this.eventHandling.resetHandler);
    }

    //private eventHandling = {
    //    $searchBox: <JQuery>null,
    //    $resetBtn: <JQuery>null,
    //    searchHandler: (query: string) => {
    //        // clear existing highlights
    //        this.$faqContainer
    //            .find('span.bg-heal-orange')
    //            .each(function () {
    //                this.outerHTML = this.innerHTML;
    //            });

    //        // show all faqs
    //        var $all = $('.accordion-item', this.$faqContainer).show();


    //        if (query == '') {
    //            console.info('query empty');
    //            //$all.removeClass('d-none');
    //            return;
    //        }

    //        // seach all searchable content handle matches
    //        $('span.searchable', $all).each(function () {
    //            var $this = $(this);
    //            var curTxt = $this.html();
    //            var idx = curTxt.toLowerCase().indexOf(query);

    //            if (idx != -1) {
    //                //highlight
    //                var matchTxt = curTxt.substr(idx, query.length)
    //                var highlight = $('<span></span>', { class: 'bg-heal-orange transparent-45' }).text(matchTxt)[0].outerHTML;
    //                $this.html(curTxt.replace(matchTxt, highlight));
    //                return;
    //            }

    //            $this.closest('.accordion-item').hide();
    //        });

    //    },
    //    resetHandler: () => {
    //        this.eventHandling.$searchBox.val('').trigger('input');
    //    }
    //}

    private replaceKeys = (template, data) => {
        const pattern = /{\s*(\w+?)\s*}/g; // {property}
        return template.replace(pattern, (_, token) => data[token] || '');
    }



}

interface QnA {
    Question: string;
    Answer: string;
}

interface FAQ {
    Url: string;
    Data: QnA[];
}